import React, { Component } from 'react'; 

class SMK extends Component{ 
    componentDidMount(){
    window.startx();
  }
    render(){ 
        return (
          <div id="main" className="wrapper style1">
            <div className="container">
              <header className="major">
                <h2>Super Mario Kart</h2>
              </header>
              <span className="containerjuego">
          <div className="content">
            <div>
            </div>
<iframe src="https://www.retrogames.cc/embed/18635-super-mario-kart-usa-hack-by-ok-impala-v1-0-super-mario-kart-the-impala-battles-custom-battle-tracks.html" width= "1080px" height="720px" title='SMK'> </iframe>
          </div>
            <div>
            <div className="containerjuego">
               <a href="/juego" className="button">Regresar</a>
            </div>
            </div>
            </span>
          </div>
          </div>
          );
    } 
} 

export default SMK;